import { render, staticRenderFns } from "./PatientOverview.vue?vue&type=template&id=49d04776&scoped=true"
import script from "./PatientOverview.vue?vue&type=script&lang=js"
export * from "./PatientOverview.vue?vue&type=script&lang=js"
import style0 from "./PatientOverview.vue?vue&type=style&index=0&id=49d04776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d04776",
  null
  
)

export default component.exports